<template>
  <div/>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    pageName: String
  },
  mounted() {
    this.isDTMReady();
  },
  computed: {
    ...mapState({
      dtm: state => state.dtm
    })
  },
  methods: {
    isDTMReady() {
      var trackingObject = {
        pageName: this.pageName
      };
    }
  }
};
</script>

<style>
</style>
